import { computed } from '@preact/signals-react';
import TabLabel from 'AppointmentBox/TabLabel';
import { ADD_APPOINTMENT_TABS } from 'AppointmentBox/helper';
import aptSignal from 'AppointmentBox/signal';
import { InputRef, Row } from 'antd';
import styled from 'styled-components';
import { ICustomerUI } from 'types/customer';
import Customer from './Customer';
import InputSearch from './InputSearch';
import shopSelectors from 'services/selectors/shop';
import { useEffect, useRef, useState } from 'react';
import InputSearchByName from './InputSearchByName';
import MyModal from 'components/Modal';

const Label = () => {
  const activeKey = computed<string>(() => aptSignal.tabSignal.value).value;
  const customer = computed(() => aptSignal.customerSignal.value).value;
  return (
    <TabLabel
      label='Customer'
      tabIndex={1}
      completed={!!customer?.id}
      active={activeKey === ADD_APPOINTMENT_TABS.CUSTOMER}
    />
  );
};
enum ESearchBy {
  PHONE = 'PHONE',
  NAME = 'NAME'
}
const Children = () => {
  const customer = computed(() => aptSignal.customerSignal.value).value;
  const customers = shopSelectors.customers();
  const inputRef = useRef<InputRef>(null);
  const handleChooseCustomer = (o: ICustomerUI) => () => {
    aptSignal.customerSignal.value = o;
    aptSignal.defaultCustomerSignal.value = null;
    aptSignal.next();
  };
  useEffect(() => {
    if (!aptSignal.openSignal.value) return;
    setTimeout(() => inputRef.current?.focus(), 100);
  }, [aptSignal.openSignal.value]);

  return (
    <CustomerTabStyled>
      <InputSearchBox inputPhoneRef={inputRef} />
      <Customers wrap>
        {aptSignal.defaultCustomerSignal.value && <CustomerWrap key={aptSignal.defaultCustomerSignal.value.id}>
          <div className='box'>
            <Customer
              active
              data={aptSignal.defaultCustomerSignal.value}
            />
          </div>
        </CustomerWrap>}
        {customers.map(o => (
          <CustomerWrap key={o.id}>
            <div className='box'>
              <Customer
                active={o.id === customer?.id}
                data={o}
                onClick={handleChooseCustomer(o)}
              />
            </div>
          </CustomerWrap>
        ))}
      </Customers>
    </CustomerTabStyled>
  );
};

export const InputSearchBox = ({ inputPhoneRef, onSelect }: { inputPhoneRef: React.RefObject<InputRef>, onSelect?: (o: ICustomerUI) => void; }) => {
  const [searchBy, setSearchBy] = useState<ESearchBy>(ESearchBy.PHONE);
  const inputRef = useRef<InputRef>(null);
  const handleChooseCustomer = (o: ICustomerUI) => () => {
    if (onSelect) return onSelect(o);
    aptSignal.customerSignal.value = o;
    aptSignal.defaultCustomerSignal.value = null;
    aptSignal.next();
  };
  const onChangeSearchBy = (val: ESearchBy) => {
    setSearchBy(val);
    setTimeout(() => {
      if (val === ESearchBy.NAME)
        inputRef.current?.focus();
      else
        inputPhoneRef.current?.focus();
    }, 100);
  };

  return (
    <SearchContainer>
      <div className="tags">
        <span>Search By: </span>
        <button onClick={() => onChangeSearchBy(ESearchBy.PHONE)} className={`tag-item ${searchBy === ESearchBy.PHONE ? 'active' : ''}`}>Phone</button>
        <button onClick={() => onChangeSearchBy(ESearchBy.NAME)} className={`tag-item ${searchBy === ESearchBy.NAME ? 'active' : ''}`}>Name</button>
        <div style={{ flex: 1 }} />
        <button onClick={handleChooseCustomer({ id: '0', name: 'Walk-In', phone: '0000000000' })} className={'tag-item walk-in'}>Walk-In</button>
      </div>
      {searchBy === ESearchBy.PHONE && <InputSearch inputRef={inputPhoneRef} onSelect={(o) => handleChooseCustomer(o)()} />}
      {searchBy === ESearchBy.NAME && <InputSearchByName inputRef={inputRef} onSelect={(o) => handleChooseCustomer(o)()} />}
    </SearchContainer>
  );
};

const WalkInModal = ({ onSelect = () => undefined }: { onSelect?: (o: ICustomerUI) => void }) => {
  const inputRef = useRef<InputRef>(null);
  const customers = shopSelectors.customers();
  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    setOpen(true);
    setTimeout(() => inputRef.current?.focus(), 100);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleOk = () => {
    setOpen(false);
  };
  const handleChooseCustomer = (o: ICustomerUI) => {
    setOpen(false);
    onSelect(o);
  };

  return <>
    <ButtonChange onClick={handleOpen}><Change /></ButtonChange>
    <MyModal
      open={open}
      onCancel={handleClose}
      title="CHOOSE CUSTOMER"
      onOk={handleOk}
    >
      <CustomerTabStyled style={{ padding: 16 }}>
        <InputSearchBox inputPhoneRef={inputRef} onSelect={handleChooseCustomer} />
        <Customers wrap>
          {customers.map(o => (
            <CustomerWrap key={o.id}>
              <div className='box'>
                <Customer
                  active={false}
                  data={o}
                  onClick={() => handleChooseCustomer(o)}
                />
              </div>
            </CustomerWrap>
          ))}
        </Customers>
      </CustomerTabStyled>
    </MyModal>
  </>;
};

const CustomerTab = {
  Label,
  Children,
  WalkInModal,
};

export default CustomerTab;
const CustomerTabStyled = styled.div`
  height: 100%;
`;

const Customers = styled(Row)`
  display: flex;
  margin: -6px;
  margin-top: 12px;
`;

const CustomerWrap = styled.div`
  width: 20%;
  .box {
    margin: 6px;
  }
`;

const SearchContainer = styled.div`
  .tags {
    font-family: Poppins;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    color: #1D2129;
    margin-bottom: 8px;
    gap: 8px;
    display: flex;
    align-items: center;
    button {
      font-family: Poppins;
      font-size: 18px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      color: #7B7B7B;
      padding: 4px 16px;
      border-radius: 2px;
      border: 1px solid #7B7B7B;
      background: #EEE;
      border-radius: 8px;
      &.active {
        background: #232F3E;
        border-color: #232F3E;
        color: #fff;
      }

      &.walk-in {
        background: #F05326;
        border-color: #F05326;
        color: #fff;
      }
    }
  }
`;

const ButtonChange = styled.button`
  display: flex;
  height: 30px;
  width: 40px;
  margin-left: 4px;
  align-items: center;
  justify-content: center;
  &:hover {
    background: #e9e8e8;
  }
`;

const Change = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M8.93056 8.92701C10.4219 7.43572 12.2633 6.51544 14.1896 6.16257L13.7091 3.53955C11.2676 3.98682 8.93103 5.15531 7.04494 7.0414C2.0983 11.988 2.0983 20.0081 7.04494 24.9548L4.7688 27.2309H11.2067V20.793L8.93056 23.0692C5.02532 19.1639 5.02532 12.8323 8.93056 8.92701ZM27.2321 4.76762H20.7942V11.2055L23.0703 8.92938C26.9756 12.8346 26.9756 19.1663 23.0703 23.0715C21.579 24.5628 19.7375 25.4831 17.8113 25.836L18.2918 28.459C20.7333 28.0117 23.0699 26.8432 24.9559 24.9571C29.9026 20.0105 29.9026 11.9904 24.9559 7.04376L27.2321 4.76762Z" fill="#148CF1" />
    </svg>
  );
};
